<template>
    <div>
        <router-view @childrenRoute="hideNonChildren" />
        <div v-if="!isChildRoute">
            <div class="row p-4">
                <div class="col-md-12">
                    <OverviewMaintenance />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Maintenance from '@/components/page/Maintenance.js'
import BarCard from '@/views/pages/BarCard.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import Loader from '@/components/loader/Loader2.vue'
import PieChart from '@/components/chart/Pie.js'
import { AxiosWithJar, Config, Penanggalan, FuelColor, Rainbow} from '@/utility.js'
import OverviewMaintenance from '@/views/pages/OverviewMaintenance.vue'

export default
{
	extends:Maintenance,
	components: {
        OverviewMaintenance,
		//ReportResultTable,
		//Loader,
	},
    data() {
		return {
            isChildRoute: false,
			tabList:[
				{name:'Station'},
			],
        }
    },
	computed: {

	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
    },
    mounted() {
        this.hideNonChildren();
    },
    methods: {
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/maintenance';
        },
    },
}
</script>
